import {useUuid} from "~/composables/useUuid";
export default defineNuxtRouteMiddleware((to, from) => {
  useUuid().setupUuid()
})